"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuildQuestToJSON = exports.GuildQuestFromJSONTyped = exports.GuildQuestFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GuildQuestFromJSON(json) {
    return GuildQuestFromJSONTyped(json, false);
}
exports.GuildQuestFromJSON = GuildQuestFromJSON;
function GuildQuestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guild': !(0, runtime_1.exists)(json, 'guild') ? undefined : json['guild'],
        'game': !(0, runtime_1.exists)(json, 'game') ? undefined : json['game'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'isGuildQualifier': !(0, runtime_1.exists)(json, 'isGuildQualifier') ? undefined : json['isGuildQualifier'],
        'eventType': (0, _1.OWGameEventTypeFromJSON)(json['eventType']),
        'target': json['target'],
        'milestones': !(0, runtime_1.exists)(json, 'milestones') ? undefined : (json['milestones'].map(_1.MilestoneResponseFromJSON)),
        'rewardConfigs': !(0, runtime_1.exists)(json, 'rewardConfigs') ? undefined : (json['rewardConfigs'].map(_1.RewardConfigResponseFromJSON)),
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
        'mode': !(0, runtime_1.exists)(json, 'mode') ? undefined : (0, _1.GuildQuestModeFromJSON)(json['mode']),
        'dailyTarget': !(0, runtime_1.exists)(json, 'dailyTarget') ? undefined : json['dailyTarget'],
        'userStat': !(0, runtime_1.exists)(json, 'userStat') ? undefined : (0, _1.GuildQuestUserStatFromJSON)(json['userStat']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.GuildQuestFromJSONTyped = GuildQuestFromJSONTyped;
function GuildQuestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guild': value.guild,
        'game': value.game,
        'name': value.name,
        'description': value.description,
        'isGuildQualifier': value.isGuildQualifier,
        'eventType': (0, _1.OWGameEventTypeToJSON)(value.eventType),
        'target': value.target,
        'milestones': value.milestones === undefined ? undefined : (value.milestones.map(_1.MilestoneResponseToJSON)),
        'rewardConfigs': value.rewardConfigs === undefined ? undefined : (value.rewardConfigs.map(_1.RewardConfigResponseToJSON)),
        'isActive': value.isActive,
        'mode': (0, _1.GuildQuestModeToJSON)(value.mode),
        'dailyTarget': value.dailyTarget,
        'userStat': (0, _1.GuildQuestUserStatToJSON)(value.userStat),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.GuildQuestToJSON = GuildQuestToJSON;
